<template>
  <div class="apps">
    <v-expansion-panels v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-title class="apps-title">
          Auto Dialer applications
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div class="apps-content">
            <div
              v-for="app in apps"
              :key="app.id"
              class="single-marketing-app d-flex flex-column flex-sm-row justify-space-between align-center"
            >
              <div class="name-image d-flex align-center ga-4">
                <img
                  width="40px"
                  height="40px"
                  :src="app.image"
                  :alt="app.name"
                  @error="onImageError($event, app)"
                />
                <div class="name-desc d-flex flex-column ga-2">
                  <div class="name">{{ app.name }}</div>
                  <span
                    class="desc"
                    v-html="getDescriptionWithBoldName(app)"
                  ></span>
                </div>
              </div>
              <div class="action d-flex align-center ga-3">
                <!--
                <div
                  v-if="app.status === 'active'"
                  @click="goToInsights(app.id)"
                  class="insights"
                >
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.1304 5.21825H21.9999V20.5833H19.1304V5.21825Z"
                      fill="#237276"
                    />
                    <path
                      d="M14.3479 10.0199H17.2175V20.5834H14.3479V10.0199Z"
                      fill="#237276"
                    />
                    <path
                      d="M0 10.9802H2.86957V20.5834H0V10.9802Z"
                      fill="#237276"
                    />
                    <path
                      d="M9.56519 11.9405H12.4348V20.5834H9.56519V11.9405Z"
                      fill="#237276"
                    />
                    <path
                      d="M4.78259 8.09927H7.65216V20.5834H4.78259V8.09927Z"
                      fill="#237276"
                    />
                    <path
                      d="M22 1.85715C22 2.23919 21.8488 2.60558 21.5798 2.87572C21.3107 3.14586 20.9457 3.29762 20.5652 3.29762C20.352 3.29644 20.1415 3.24894 19.9483 3.15838L17.0787 6.03933C17.1741 6.23153 17.2216 6.44405 17.2174 6.65874C17.2174 7.04077 17.0662 7.40716 16.7972 7.67731C16.5281 7.94745 16.1631 8.09921 15.7826 8.09921C15.5796 8.10016 15.3787 8.05784 15.1932 7.97507C15.0077 7.8923 14.8418 7.77096 14.7065 7.61905L12.4348 8.52655C12.4374 8.54406 12.4374 8.56186 12.4348 8.57937C12.4348 8.96141 12.2836 9.3278 12.0145 9.59794C11.7455 9.86808 11.3805 10.0198 11 10.0198C10.6195 10.0198 10.2545 9.86808 9.98546 9.59794C9.71638 9.3278 9.56522 8.96141 9.56522 8.57937C9.56431 8.41579 9.59182 8.2533 9.64652 8.09921L6.97304 5.9529C6.74709 6.09749 6.48532 6.17567 6.21739 6.17858C5.84739 6.18014 5.49168 6.03523 5.22739 5.77524L2.86957 6.96604C2.87429 7.02356 2.87429 7.08137 2.86957 7.13889C2.86977 7.471 2.75567 7.79298 2.54657 8.05032C2.33747 8.30766 2.04622 8.48456 1.72213 8.55107C1.39804 8.61759 1.06101 8.56962 0.768094 8.41531C0.47518 8.26099 0.244375 8.0098 0.114749 7.70425C-0.0148771 7.3987 -0.0353601 7.05757 0.0567668 6.73861C0.148894 6.41964 0.347971 6.14243 0.6203 5.9539C0.892628 5.76537 1.22148 5.67711 1.55118 5.70405C1.88089 5.731 2.19119 5.87149 2.42957 6.10175L4.78261 4.91576C4.77788 4.85663 4.77788 4.79722 4.78261 4.7381C4.78261 4.35606 4.93377 3.98967 5.20285 3.71953C5.47192 3.44939 5.83686 3.29762 6.21739 3.29762C6.59792 3.29762 6.96286 3.44939 7.23194 3.71953C7.50101 3.98967 7.65217 4.35606 7.65217 4.7381C7.65358 4.90172 7.62605 5.0643 7.57087 5.21826L10.2396 7.36457C10.4669 7.21912 10.7304 7.14091 11 7.13889C11.203 7.13795 11.4039 7.18026 11.5894 7.26303C11.7749 7.3458 11.9408 7.46715 12.0761 7.61905L14.3478 6.71635C14.3455 6.69722 14.3455 6.67787 14.3478 6.65874C14.3478 6.2767 14.499 5.91031 14.7681 5.64016C15.0371 5.37002 15.4021 5.21826 15.7826 5.21826C15.9964 5.21953 16.2072 5.26875 16.3996 5.36231L19.2691 2.48135C19.1769 2.28635 19.1295 2.07302 19.1304 1.85715C19.1304 1.47511 19.2816 1.10872 19.5507 0.838577C19.8197 0.568436 20.1847 0.416672 20.5652 0.416672C20.9457 0.416672 21.3107 0.568436 21.5798 0.838577C21.8488 1.10872 22 1.47511 22 1.85715Z"
                      fill="#237276"
                    />
                  </svg>
                </div>
-->

                <div class="status">
                  <button
                    @click="connectApp(app.id)"
                    title="Connect"
                    v-if="app.status === 'inactive'"
                    class="connect"
                  >
                    Connect
                  </button>
                  <button
                    @click="openDisappDialog(app)"
                    title="Disable"
                    v-if="app.status === 'active'"
                    class="disable"
                  >
                    Disable
                  </button>
                </div>
              </div>
            </div>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <template>
    <v-dialog v-model="disable_dialog" max-width="500" persistent>
      <div class="disable-dialog-container">
        <div class="header d-flex justify-space-between align-center w-100">
          <div class="icon">
            <svg
              width="56"
              height="57"
              viewBox="0 0 56 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="4.5"
                width="48"
                height="48"
                rx="24"
                fill="#FEE4E2"
              />
              <rect
                x="4"
                y="4.5"
                width="48"
                height="48"
                rx="24"
                stroke="#FEF3F2"
                stroke-width="8"
              />
              <path
                d="M32 22.5V21.7C32 20.5799 32 20.0198 31.782 19.592C31.5903 19.2157 31.2843 18.9097 30.908 18.718C30.4802 18.5 29.9201 18.5 28.8 18.5H27.2C26.0799 18.5 25.5198 18.5 25.092 18.718C24.7157 18.9097 24.4097 19.2157 24.218 19.592C24 20.0198 24 20.5799 24 21.7V22.5M26 28V33M30 28V33M19 22.5H37M35 22.5V33.7C35 35.3802 35 36.2202 34.673 36.862C34.3854 37.4265 33.9265 37.8854 33.362 38.173C32.7202 38.5 31.8802 38.5 30.2 38.5H25.8C24.1198 38.5 23.2798 38.5 22.638 38.173C22.0735 37.8854 21.6146 37.4265 21.327 36.862C21 36.2202 21 35.3802 21 33.7V22.5"
                stroke="#CC0000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div @click="disable_dialog = false" class="close">
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 1.5L1 13.5M1 1.5L13 13.5"
                stroke="#717680"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <div class="body">
          <div class="title">Disconnect {{ current_app.name }}</div>
          <div class="text">
            Are you sure you want to disconnect {{ current_app.name }} ?
          </div>
        </div>
        <div class="footer d-flex justify-space-around align-center">
          <button @click="disable_dialog = false" class="cancel">Cancel</button>
          <button @click="disableApp(current_app)" class="disable">
            Disable
          </button>
        </div>
      </div>
    </v-dialog>
  </template>
</template>

<script>
// import apiClient from "@/core/buildRequest";
import { toast } from "vue3-toastify";

export default {
  name: "IntegrationsIndex",
  data() {
    return {
      panel: 0,
      apps: [
        {
          id: 1,
          name: "genesys",
          image: "https://backend.promxa.com/public/images/icons/genesys.svg",
          description:
            "Connect your genesys account to streamline ad management and campaign tracking. Unlock powerful tools to optimize your marketing efforts and drive results!",
          status: "active",
        },
        {
          id: 1,
          name: "Ziwo",
          image: "https://backend.promxa.com/public/images/icons/ziwo.svg",
          description:
            "Connect your Ziwo account to streamline ad management and campaign tracking. Unlock powerful tools to optimize your marketing efforts and drive results!",
          status: "inactive",
        },
      ],
      disable_dialog: false,
      current_app: {},
    };
  },
  methods: {
    getDescriptionWithBoldName(app) {
      return app.description.replace(app.name, `<strong>${app.name}</strong>`);
    },
    connectApp(id) {
      const app = this.apps.filter((app) => app.id === id)[0];
      const platform_name = app.name.toLowerCase();
      toast(platform_name + " Soon", {
        type: "success",
      });
    },
    openDisappDialog(app) {
      this.current_app = app;
      this.disable_dialog = true;
    },
    disableApp(app) {
      const platform_name = app.name.toLowerCase();
      localStorage.removeItem(platform_name + "_token");
      if (!localStorage.getItem(platform_name + "_token")) {
        toast(platform_name + " has been disabled", {
          type: "success",
        });
        const currentIndex = this.apps.findIndex(
          (app) => app.id === this.current_app.id
        );
        this.apps[currentIndex].status = "inactive";
      }
      this.disable_dialog = false;
    },
    onImageError(event, app) {
      if (!event.target.dataset.fallback) {
        event.target.src = require("@/assets/images/integration/" +
          app.name +
          ".png");
        event.target.dataset.fallback = "true";
      }
    },
  },
};
</script>

<style>
.apps {
  margin-bottom: 35px;
}
.apps .v-expansion-panels {
  padding: 40px 24px 40px 24px;
  gap: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
}
.apps-title {
  color: rgba(6, 19, 20, 1);
  font-size: 18px;
  font-weight: 700;
  line-height: 21.78px;
}
.apps-content {
  padding: 16px 30px;
}
.apps-content .single-marketing-app:not(:last-child) {
  border-bottom: solid 1px rgba(230, 230, 230, 1);
}
.name-image .name-desc .name {
  font-size: 14px;
  font-weight: 600;
  line-height: 15px;
  color: rgba(0, 0, 0, 1);
}
.name-image .name-desc .desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(83, 100, 113, 1);
  max-width: 70%;
}
.single-marketing-app {
  margin: 21px 0px;
  padding: 18px 0px;
}
.single-marketing-app .action .status button {
  width: 98px;
  height: 32px;
  border-radius: 8px;
}
.single-marketing-app .action .status .connect:hover {
  background: rgb(23, 72, 75);
}
.single-marketing-app .action .status .connect {
  background: rgba(35, 114, 118, 1);
  color: white;
}
.single-marketing-app .action .status .disable:hover {
  background: rgb(199, 199, 199);
}
.single-marketing-app .action .status .disable {
  background: rgba(230, 230, 230, 1);
  color: rgba(102, 102, 102, 1);
}
.action .insights,
.action .add {
  cursor: pointer;
}
.v-application__wrap {
  min-height: unset !important;
}
.disable-dialog-container {
  width: 100%;
  height: 100%;
  padding: 16px 24px 16px 24px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 20px 24px -4px rgba(10, 13, 18, 0.1);
}
.disable-dialog-container .body {
  padding: 15px 0px;
  margin-bottom: 20px;
}
.disable-dialog-container .body .title {
  font-size: 20px;
  font-weight: 600;
  line-height: 24.2px;
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
}
.disable-dialog-container .header .close {
  cursor: pointer;
}
.disable-dialog-container .body .text {
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  color: rgba(106, 106, 106, 1);
}
.disable-dialog-container .footer .cancel:hover {
  background: rgb(212, 212, 212);
}
.disable-dialog-container .footer .cancel {
  width: 170px;
  height: 44px;
  padding: 10px 18px 10px 18px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(213, 215, 218, 1);
  color: rgba(65, 70, 81, 1);
}
.disable-dialog-container .footer .disable:hover {
  background: rgb(161, 2, 2);
}
.disable-dialog-container .footer .disable {
  width: 170px;
  height: 44px;
  padding: 10px 18px 10px 18px;
  border-radius: 8px;
  background: rgba(204, 0, 0, 1);
  border: 1px solid rgba(204, 0, 0, 1);
  color: white;
}
</style>
